import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';

import { select, Store, Action } from '@ngrx/store';

import * as fromPrescription from './prescription.reducer';
import * as PrescriptionSelectors from './prescription.selectors';
import * as PrescriptionActions from './prescription.actions';
import {
  PrescriptionDTO,
  UpdatePrescriptionDTO,
  LoadType,
  Fulfillment
} from '@care-portals/api-interfaces';

@Injectable()
export class PrescriptionFacade {
  loading$ = this.store.pipe(
    select(PrescriptionSelectors.getPrescriptionsLoading)
  );
  creating$ = this.store.pipe(
    select(PrescriptionSelectors.getPrescriptionsCreating)
  );
  updating$ = this.store.pipe(
    select(PrescriptionSelectors.getPrescriptionsUpdating)
  );
  sending$ = this.store.pipe(
    select(PrescriptionSelectors.getPrescriptionsSending)
  );
  allPrescription$ = this.store.pipe(
    select(PrescriptionSelectors.getAllPrescription)
  );
  selectedPrescription$ = this.store.pipe(
    select(PrescriptionSelectors.getSelected)
  );
  prescriptions$ = this.store.pipe(
    select(PrescriptionSelectors.getPrescriptionEntities)
  );
  fulfillmentOrderId$ = this.store.pipe(
    select(PrescriptionSelectors.getFulfillmentOrderId)
  );
  sendPrescriptionPdfToChatCompleted$ = this.actions$.pipe(
    ofType(
      PrescriptionActions.sendPrescriptionPdfToChatSuccess,
      PrescriptionActions.sendPrescriptionPdfToChatFailure
    )
  );

  constructor(
    private store: Store<fromPrescription.PrescriptionPartialState>,
    private readonly actions$: Actions
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadPrescriptions(loadType: LoadType, filters: any, reset: boolean = false) {
    if (reset) {
      this.dispatch(PrescriptionActions.resetRx());
    }
    this.dispatch(PrescriptionActions.loadPrescriptions({ loadType, filters }));
  }

  fetchPrescription(prescriptionId: string) {
    this.dispatch(PrescriptionActions.fetchPrescription({ prescriptionId }));
  }

  createPrescription(
    prescription: PrescriptionDTO,
    orderId?: number,
    sendRx?: boolean
  ) {
    this.dispatch(
      PrescriptionActions.createPrescription({ prescription, orderId, sendRx })
    );
  }

  updatePrescription(
    id: string,
    prescription: UpdatePrescriptionDTO,
    linkToOrderContext?: {
      orderId: number;
      transferOutAfterLink: boolean;
    }
  ) {
    this.dispatch(
      PrescriptionActions.updatePrescription({
        id,
        data: prescription,
        linkToOrderContext
      })
    );
  }

  addFulfillment(id: string, fulfillment: Fulfillment) {
    this.dispatch(PrescriptionActions.addFulfillment({ id, fulfillment }));
  }

  sendRx(rxId: string) {
    this.dispatch(PrescriptionActions.sendRx({ rxId }));
  }

  downloadPrescriptionPdf(rxId: string) {
    this.dispatch(PrescriptionActions.downloadPrescriptionPdf({ rxId }));
  }

  sendPrescriptionPdfToPatientChat(rxId: string, orderId?: number): void {
    this.dispatch(
      PrescriptionActions.sendPrescriptionPdfToChat({ rxId, orderId })
    );
  }

  resetFulfillmentState() {
    this.dispatch(PrescriptionActions.resetFulfillmentState());
  }
}
